/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';

import {Badge, BadgeColors} from './Badge';
import Link from './Link';
import {createURLWithParams} from '../util';
import extractRole from '../util/resourceRole';

const ResourceCard = ({
  badge, post, trackerEvent, urlParams,
}) => {
  const router = useRouter();
  const url = `/resources/${post.slug}`;

  const handleClick = () => {
    trackerEvent?.();
    router.push(createURLWithParams(url, urlParams));
  };

  const hasThumbnail = Boolean(post.thumbnail);
  const role = extractRole(post.shortTitle || post.title);

  return (
    <div
      onClick={handleClick}
      className="group cursor-pointer h-full flex flex-col py-4 px-5 border border-gray-200 rounded-lg hover:border-gray-300 hover:shadow-sm transition duration-150 overflow-hidden"
    >
      {hasThumbnail && (
        <div className="hidden md:flex relative -mt-4 -mx-5 mb-4 h-36 justify-center items-center bg-gray-100">
          <img
            src={`${post.thumbnail}?w=800&h=800`}
            className="w-full h-full object-cover"
            loading="lazy"
            width="400"
            height="200"
            alt={post.title}
          />
          <div className="absolute inset-0 w-full h-full bg-gray-200 opacity-10" />
          {badge && <Badge className="absolute top-2 right-2">{badge}</Badge>}
        </div>
      )}
      <div className="flex flex-col flex-1 w-full">
        {role && (
          <span className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-indigo-500">
            {role}
          </span>
        )}
        <Link href={url}>
          <h3 className="text-base font-semibold leading-snug text-gray-900 group-hover:text-indigo-600 transition-colors">{post.shortTitle || post.title}</h3>
        </Link>
        {post.description && (
          <p className="mt-2 text-sm leading-5 text-gray-600 line-clamp-2">{post.description}</p>
        )}
        {!hasThumbnail && badge && (
          <div className="mt-3">
            <Badge color={BadgeColors.GREEN}>{badge}</Badge>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResourceCard;
